import { InfiniteData } from '@tanstack/react-query';
import { IAssembly, IAssemblyComponent } from 'src/interfaces';

export interface SummaryPageProps {
  handleCloseSummaryPage: () => void;
  updatedAssemblyComponents: number[];
  assemblyData?: IAssembly[];
  assemblyComponentsData?: InfiniteData<{
    assemblieComponents: IAssemblyComponent[];
    totalPages: any;
  }>;
  stageBulkDisplayName?: string;
}

export enum SUMMARY_PAGE_COLUMN {
  ASSEMBLY_NAME = 'assemblyName',
  CHANNEL_TYPE = 'channelType',
  NO_OF_LOCATION_GROUPS = 'noOfLocationGroups',
  STATE = 'state',
  TAGS = 'tags',
  TOGGLE = 'toggle',
}
